export default {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
    NO_RECORDS: 'NO_RECORDS'
};
